export const USER_ROLE = "user";
export const CORPORATE_ADMIN = "admin";
